import { MolsonBox, MolsonIcon, MolsonTypography } from '@components/reusable'
import { Fade } from '@mui/material'
import { molsonUseTheme } from '@theme/customMuiExports'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export const RevisedLabel = ({
  translationPrefix
}: {
  translationPrefix: string
}) => {
  const theme = molsonUseTheme()
  const { t } = useTranslation('', {
    keyPrefix: translationPrefix
  })

  const [display, setDisplay] = useState(true)
  const [fadeEffect, setFadeEffect] = useState(true)

  const effectTimeout = 300

  useEffect(() => {
    const displayTime = 2000
    const effectTime = displayTime - 2 * effectTimeout
    const displayTimeout = setTimeout(() => {
      setDisplay(false)
    }, displayTime)

    const fadeEffectTimeout = setTimeout(() => {
      setFadeEffect(false)
    }, effectTime)

    return () => {
      clearTimeout(fadeEffectTimeout)
      clearTimeout(displayTimeout)
    }
  }, [])

  if (display) {
    return (
      <Fade in={fadeEffect} timeout={effectTimeout}>
        <div>
          <MolsonBox
            sx={{
              backgroundColor: theme.palette.secondary[50],
              border: `1px solid ${theme.palette.primary.error}`,
              borderRadius: '8px',
              gap: 1.5,
              padding: 2
            }}
            component="div"
            display="flex"
          >
            <MolsonIcon variant="CHECK_CIRCLE_OUTLINE" iconColor="success" />
            <MolsonTypography>{t('revised')}</MolsonTypography>
          </MolsonBox>
        </div>
      </Fade>
    )
  }

  return null
}
